import {styled} from '@mui/material/styles'
import {SaveButton} from '../../ProjectDetails/ProjectDetailStyle'
import ErrorIcon from '@mui/icons-material/Error'
import Box from '@mui/material/Box'
import Alert from '@mui/material/Alert'
import Snackbar from '@mui/material/Snackbar'

export const StyledButton = styled(SaveButton)(({theme}) => ({
  backgroundColor: theme.palette.hpAccentGreenVivid,
  marginTop: theme.spacing(3),
  width: 'fit-content',
  '&:hover': {
    backgroundColor: theme.palette.hpAccentGreenVivid,
    cursor: 'default'
  }
}))

export const StyledErrorIcon = styled(ErrorIcon)(({theme}) => ({
  color: theme.palette.hpAccentRed
}))

export const StyledSnackbar = styled(Snackbar)(() => ({
  top: '85vh'
}))

export const StyledAlertErrorBox = styled(Box, {shouldForwardProp: (prop) => prop !== 'showNotification'})(
  ({theme, showNotification, iscreateuser}) => ({
    width: 'fit-content',
    marginTop: showNotification ? theme.spacing(2) : '0px',
    marginBottom: showNotification ? theme.spacing(2) : '0px',
    position: iscreateuser === 'true' ? '' : 'fixed',
    zIndex: iscreateuser === 'true' ? '' : 999,
    top: iscreateuser === 'true' ? '' : '88vh'
  })
)

export const StyledAlert = styled(Alert)(({theme}) => ({
  mb: 2,
  fontSize: theme.typography.subtitle1.fontSize,
  color: theme.palette.hpAccentBlack,
  border: `2px solid ${theme.palette.hpAccentRed}`,
  padding: `0px ${theme.spacing(1)} 0px ${theme.spacing(1)}`
}))
